import enUs from "./en-us";
export default {
  'en-us': enUs
};